import { Button, mergeClasses } from '@fluentui/react-components';
import { ChevronDown12Filled, ChevronDown12Regular, } from '@fluentui/react-icons';
import React, { forwardRef, useMemo } from 'react';
import { useFluentPillStyles } from './FluentPillControl.styles';
/* Non-interactive pill */
export var FluentPillControl = forwardRef(function (_a, ref) {
    var id = _a.id, title = _a.title, isActive = _a.isActive, iconElement = _a.iconElement, iconElementRight = _a.iconElementRight, isDropdown = _a.isDropdown;
    var fluentStyles = useFluentPillStyles();
    var pillIcon = useMemo(function () {
        return React.createElement("div", { className: fluentStyles.icon }, iconElement);
    }, [fluentStyles.icon, iconElement]);
    var dropdownIcon = useMemo(function () {
        return isActive ? (React.createElement(ChevronDown12Filled, { className: fluentStyles.dropdownIcon })) : (React.createElement(ChevronDown12Regular, { className: fluentStyles.dropdownIcon }));
    }, [fluentStyles.dropdownIcon, isActive]);
    //Render pill as span if it does not need interactivity
    return title ? (React.createElement(Button, { id: id, shape: "circular", appearance: "outline", tabIndex: -1, className: isActive
            ? mergeClasses(fluentStyles.pill, fluentStyles.pillSelected)
            : fluentStyles.pill, ref: ref },
        pillIcon,
        title,
        iconElementRight ? (React.createElement("div", { className: isActive
                ? mergeClasses(fluentStyles.likelihoodIconContainer, fluentStyles.likelihoodIconSelected)
                : mergeClasses(fluentStyles.likelihoodIconContainer, fluentStyles.likelihoodIcon) }, iconElementRight)) : null,
        isDropdown && dropdownIcon)) : null;
});
FluentPillControl.displayName = 'FluentPillControl';
//# sourceMappingURL=FluentPillControl.js.map